import execa from 'execa'
import log from 'loglevel';
import { PassThrough } from "stream"

export const exec = async (command: string, options?: execa.Options): Promise<string> => {
  log.debug(`Executing command "${command}"`)

  // Create PassThrough stream
  const pass = new PassThrough();
  // Console log stream data
  pass.on("data", (chunk: Buffer | string | any) => {
    log.debug(chunk.toString());
  });

  // execa rejects on non-zero exit codes, so failures propagate to the caller
  const subprocess = execa.command(command, options);
  subprocess.stdout.pipe(pass);
  const result = await subprocess;
  log.debug(result)

  return result.stdout;

}